import {Emisor} from "../../emisor/recursos/modelo/emisor";

export class Configuracion {
    public id: number;
    public passwordRegex: string;
    public numberAttempts: string;
    public passwordExpirationDays: string;
    public numberPasswordRemember: string;
    public customer: any;
    public logEstatusRegistro: string;


    constructor(id: number = null,
                passwordRegex: string = "",
                numberAttempts: string = "",
                passwordExpirationDays: string = "",
                numberPasswordRemember: string = "",
                emisor: any = new Emisor(),
                logEstatusRegistro: string = "") {
        this.id = id;
        this.numberAttempts = numberAttempts;
        this.passwordRegex = passwordRegex;
        this.passwordExpirationDays = passwordExpirationDays;
        this.numberPasswordRemember = numberPasswordRemember;
        this.customer = emisor;
        this.logEstatusRegistro = logEstatusRegistro
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/configuracion/recursos/configuracion.ts